module.exports = __webpack_public_path__ + "img/tutorial_main_01.4480c7be.png";